import React, { useSyncExternalStore } from "react";
import {
    closeAdminDialog,
    dismissAdminToast,
    getAdminDialogSnapshot,
    subscribeAdminDialog,
    type AdminToastKind,
} from "../../lib/adminDialog";

const toastStyles: Record<AdminToastKind, string> = {
    success:
        "bg-emerald-50 border-emerald-200 text-emerald-900 dark:bg-emerald-950/80 dark:border-emerald-800 dark:text-emerald-100",
    error: "bg-red-50 border-red-200 text-red-900 dark:bg-red-950/80 dark:border-red-800 dark:text-red-100",
    warning:
        "bg-amber-50 border-amber-200 text-amber-900 dark:bg-amber-950/80 dark:border-amber-800 dark:text-amber-100",
    info: "bg-blue-50 border-blue-200 text-blue-900 dark:bg-blue-950/80 dark:border-blue-800 dark:text-blue-100",
};

/** Одна модалка + тости на всю адмінку (замість window.alert/confirm). */
export const AdminDialogHost: React.FC = () => {
    const { dialog, toasts } = useSyncExternalStore(
        subscribeAdminDialog,
        getAdminDialogSnapshot,
        getAdminDialogSnapshot,
    );

    return (
        <>
            {dialog && (
                <div
                    className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50"
                    role="dialog"
                    aria-modal="true"
                    onClick={() =>
                        closeAdminDialog(dialog.mode === "confirm" ? false : undefined)
                    }
                >
                    <div
                        className="w-full max-w-md rounded-xl bg-white dark:bg-gray-800 shadow-2xl border border-gray-200 dark:border-gray-700"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="px-5 pt-5 pb-3">
                            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                                {dialog.title}
                            </h2>
                            <p className="mt-2 text-sm text-gray-600 dark:text-gray-300 whitespace-pre-line leading-relaxed">
                                {dialog.message}
                            </p>
                        </div>
                        <div className="px-5 py-4 flex justify-end gap-2 border-t border-gray-100 dark:border-gray-700">
                            {dialog.mode === "confirm" && (
                                <button
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                                    onClick={() => closeAdminDialog(false)}
                                >
                                    {dialog.cancelText || "Отмена"}
                                </button>
                            )}
                            <button
                                type="button"
                                className={`px-4 py-2 text-sm font-medium rounded-lg text-white cursor-pointer ${
                                    dialog.mode === "confirm" && dialog.danger
                                        ? "bg-red-600 hover:bg-red-700"
                                        : "bg-blue-600 hover:bg-blue-700"
                                }`}
                                onClick={() =>
                                    closeAdminDialog(
                                        dialog.mode === "confirm" ? true : undefined,
                                    )
                                }
                                autoFocus
                            >
                                {dialog.mode === "alert"
                                    ? dialog.okText || "OK"
                                    : dialog.confirmText || "Подтвердить"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="fixed top-4 right-4 z-[110] flex flex-col gap-2 w-full max-w-sm pointer-events-none">
                {toasts.map((t) => (
                    <div
                        key={t.id}
                        className={`pointer-events-auto border rounded-lg px-4 py-3 shadow-lg text-sm whitespace-pre-line ${toastStyles[t.kind]}`}
                    >
                        <div className="flex gap-2 items-start">
                            <p className="flex-1 font-medium">{t.message}</p>
                            <button
                                type="button"
                                className="opacity-60 hover:opacity-100 cursor-pointer"
                                onClick={() => dismissAdminToast(t.id)}
                            >
                                ×
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default AdminDialogHost;
